<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (alt)="altEditCropField($event)"
  (cancel)="cancelEditCropField()"
  (confirm)="confirmEditCropField($event)"
  data-test="edit-cropfield"
>
  <div class="spacing--margin-top">
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'fieldName' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'fieldName' | translate"
          formControlName="name"
          data-test="edit-cropfield-name"
        />
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'hectare' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'hectare' | translate"
          formControlName="areaInHectares"
          [min]="0.001"
          [step]="0.01"
          data-test="edit-cropfield-hectares"
        />
      </mat-form-field>
      <div class="mat-slide-group-wrapper flex__child--auto">
        <div class="mat-slide-group mat-slide-group--match-form-field-size">
          <mat-slide-toggle
            color="primary"
            formControlName="isAreaCalculated"
            data-test="edit-cropfield-isAreaCalculated"
            >{{ 'hectareCalculated' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>
    <div class="flex--row flex--gutter">
      <div class="mat-slide-group-wrapper spacing--margin-right">
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isSkal"
            data-test="edit-cropfield-isSkal"
            >{{ 'organic' | translate }}</mat-slide-toggle
          >
        </div>
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isPlanetProof"
            data-test="edit-cropfield-isPlanetProof"
            >{{ 'planetProof' | translate }}</mat-slide-toggle
          >
        </div>
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isSandySoil"
            data-test="edit-cropfield-isSandySoil"
            >{{ 'sandySoil' | translate }}
            @if (isPrefilling$ | async) {
              <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
            }
          </mat-slide-toggle>
        </div>
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isRentedField"
            data-test="edit-cropfield-isRentedField"
            >{{ 'rentedField' | translate }}
            @if (isPrefilling$ | async) {
              <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
            }
          </mat-slide-toggle>
        </div>
      </div>
      <div class="mat-slide-group-wrapper">
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isNutrientsPollutedArea"
            data-test="edit-cropfield-isNutrientsPollutedArea"
            >{{ 'isNutrientsPollutedArea' | translate }}
            @if (isPrefilling$ | async) {
              <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
            }
          </mat-slide-toggle>
        </div>
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isGroundWaterPreservation"
            data-test="edit-cropfield-isGroundWaterPreservation"
            >{{ 'isGroundWaterPreservation' | translate }}
            @if (isPrefilling$ | async) {
              <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
            }
          </mat-slide-toggle>
        </div>
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isGroundWaterPreservationWithNitrogenCuts"
            data-test="edit-cropfield-isGroundWaterPreservationWithNitrogenCuts"
            >{{ 'isGroundWaterPreservationWithNitrogenCuts' | translate }}
            @if (isPrefilling$ | async) {
              <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
            }
          </mat-slide-toggle>
        </div>
      </div>
    </div>
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'crop' | translate }} </mat-label>
        <input
          type="text"
          [placeholder]="'crop' | translate"
          matInput
          formControlName="cropId"
          [matAutocomplete]="cropAutocomplete"
          data-test="edit-cropfield-crop"
        />
        <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop()">
          @for (option of filteredCrops$ | async; track option) {
            <mat-option [value]="option.id" data-test="edit-cropfield-crop-option">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cropVariety' | translate }}</mat-label>
        <input
          type="text"
          [placeholder]="'cropVariety' | translate"
          matInput
          formControlName="cropVarietyId"
          [matAutocomplete]="cropVarietyAutocomplete"
          data-test="edit-cropfield-cropVariety"
        />
        @if (isLoadingBemCropVarieties) {
          <mat-spinner
            matSuffix
            [diameter]="20"
            [attr.aria-label]="'loadingCropVarieties' | translate"
            data-test="edit-cropfield-cropVariety-loading"
          ></mat-spinner>
        }
        <mat-autocomplete
          #cropVarietyAutocomplete="matAutocomplete"
          [displayWith]="displayCropVariety()"
        >
          @for (option of filteredCropVarieties$ | async; track option) {
            <mat-option [value]="option.id" data-test="edit-cropfield-cropVariety-option">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'buyer' | translate }}</mat-label>
        <mat-select formControlName="chainPartnerId" data-test="edit-cropfield-chainPartner">
          <mat-option [value]="null">{{ 'none' | translate }}</mat-option>
          @for (chainPartner of buyerChainPartners$ | async; track chainPartner.id) {
            <mat-option [value]="chainPartner.id">{{ chainPartner.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'concept' | translate }}</mat-label>
        <mat-select formControlName="conceptId" data-test="edit-cropfield-concept">
          <mat-option [value]="null">{{ 'none' | translate }}</mat-option>
          @for (concept of concepts$ | async; track concept.id) {
            <mat-option [value]="concept.id">{{ concept.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label
          >{{ 'soilType' | translate }}
          @if (isPrefilling$ | async) {
            <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
          }
        </mat-label>
        <mat-select formControlName="soilTypeId" data-test="edit-cropfield-soilType">
          @for (soilType of data.soilTypes; track soilType) {
            <mat-option [value]="soilType.id">
              {{ soilType.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <div class="mat-slide-group-wrapper flex__child--auto">
        <div class="mat-slide-group mat-slide-group--match-form-field-size">
          <mat-slide-toggle
            color="primary"
            formControlName="outsideDutchBorders"
            data-test="edit-cropfield-outsideDutchBorders"
            >{{ 'abroad' | translate }}
            @if (isPrefilling$ | async) {
              <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
            }
          </mat-slide-toggle>
        </div>
      </div>
      <mat-form-field class="flex__child--auto">
        <mat-label
          >{{ 'province' | translate }}
          @if (isPrefillingProvince) {
            <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
          }
        </mat-label>

        <mat-select formControlName="province" data-test="edit-cropfield-province">
          @for (province of eProvince | keyvalue; track province) {
            <mat-option [value]="province.key">
              {{ province.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'machiningDepth' | translate }} (cm)</mat-label>
        <input
          matInput
          agrNumber
          maxlength="2"
          [placeholder]="'machiningDepth' | translate"
          formControlName="machiningDepthInCentimeters"
          [min]="0"
          [step]="1"
          data-test="edit-cropfield-machiningDepthInCentimeters"
        />
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto" data-test="edit-cropfield-startDate">
        <mat-label>{{ 'startDate' | translate }}</mat-label>
        <input
          matInput
          formControlName="startDate"
          [matDatepicker]="startDatePicker"
          [placeholder]="'startDate' | translate"
        />
        <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" data-test="edit-cropfield-endDate">
        <mat-label>{{ 'endDate' | translate }}</mat-label>
        <input
          matInput
          formControlName="endDate"
          [matDatepicker]="endDatePicker"
          [placeholder]="'endDate' | translate"
        />
        <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field class="full-width-field">
        <mat-label>{{ 'soilAnalyses' | translate }}</mat-label>
        <mat-chip-grid #chipList>
          @for (soilAnalysis of selectedSoilAnalyses$ | async; track soilAnalysis; let i = $index) {
            <mat-chip-row [removable]="true" (removed)="removeSoilAnalysis(i)">
              {{ soilAnalysis?.description }} {{ getSoilAnalysisYear(soilAnalysis) }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
          }
          <input
            #soilAnalysesInput
            [placeholder]="'soilAnalyses' | translate"
            [formControl]="soilAnalysesControl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addSoilAnalysis($event)"
          />
        </mat-chip-grid>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectSoilAnalysis($event)">
          <mat-optgroup [label]="'ownSoilAnalyses' | translate">
            <mat-option [value]="false">{{ 'addManualSoilAnalysis' | translate }}</mat-option>
            @for (soilAnalysis of filteredSoilAnalyses$ | async; track soilAnalysis) {
              <mat-option [value]="soilAnalysis.id">
                {{ soilAnalysis?.description }} {{ getSoilAnalysisYear(soilAnalysis) }}
              </mat-option>
            }
          </mat-optgroup>
          <mat-optgroup [label]="'defaultSoilAnalyses' | translate">
            @for (soilAnalysis of filteredDefaultSoilAnalyses$ | async; track soilAnalysis) {
              <mat-option [value]="soilAnalysis.id">
                {{ soilAnalysis?.description }}
              </mat-option>
            }
          </mat-optgroup>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</agr-form-dialog>
